import React from "react"

const CallButton = () => {
  const areaCode = "+49"
  const middlePart = "2102"
  const lastPart = "5358010"
  const fullNumber = `${areaCode}${middlePart}${lastPart}`

  const handleCallClick = () => {
    window.location.href = `tel:${fullNumber}`
  }

  return (
    <button onClick={handleCallClick} className="call-button">
      Anrufen
    </button>
  )
}

export default CallButton
